import "./index.css";
// core.js for support es6 syntax in older browser
import "core-js/stable";
import "regenerator-runtime/runtime";

import moment from "moment";
import NProgress from "vendor/nprogress/nprogress";
import Cookies from "js-cookie";
import Vue from "vue";
import VueLazyload from "vue-lazyload";
import VModal from "vue-js-modal";
import * as alert from "lib/alert";
import moneyFormat from "lib/money";
import VueAnalytics from "vue-analytics";
import VueTimeago from "vue-timeago";
import VueObserveVisibility from "vue-observe-visibility";
import VTooltip from "v-tooltip";
import VeeValidate from "vee-validate";
import PrettyCheck from "pretty-checkbox-vue/check";
import PrettyRadio from "pretty-checkbox-vue/radio";
import Rollbar from "lib/rollbar";
import Vuex from "vuex";
import { mapGetters } from "vuex";
import VueMeta from "vue-meta";
import cdnUrl from "lib/cdnUrl";
import VueClipboard from "vue-clipboard2";

// src
import App from "../../user/App.vue";
import { i18n } from "./i18n";
import zendeskWebWidget from "../../user/helpers/zendeskWidget";
import vuexStore from "../../user/store";

import $ from "jquery";

const vMediaQuery = require("v-media-query/dist/v-media-query");
const VueScrollTo = require("vue-scrollto");

const { appConfig, clevertap } = window;

window.jQuery = window.$ = $;
window.rollbar = Rollbar;

require("vendor/magnific-popup");
// require("../../user/modernizr");

$(document).ajaxStart(NProgress.start);

$(document).ajaxStop(NProgress.done);

const $criteo = window.criteo_q || [];
moment.locale(appConfig.locale);

const fbq = window.fbq || function fbqF() { };

// if (process.env.NODE_ENV === 'production') {
Vue.config.warnHandler = function warnHandlerF(error, vm, info) {
  console.debug("report vue warn to rollbar");
  console.warn("Vue error", { error, vm, info });
  Rollbar.warn("Vue error", { error, vm, info });
};

Vue.config.errorHandler = function errorHandlerF(error, vm, info) {
  console.debug("report vue error to rollbar");
  console.error("Vue error", { error, vm, info });
  Rollbar.error("Vue error", { error, vm, info });
};
// }

Vue.prototype.$money = moneyFormat;
Vue.prototype.$alert = alert;
Vue.prototype.$rollbar = Rollbar;
Vue.prototype.$fbq = fbq;
Vue.prototype.$jq = $;
Vue.prototype.$appConfig = appConfig;
Vue.prototype.$clevertap = clevertap;
Vue.prototype.$criteo = $criteo;

const VueMoment = require("vue-moment");
Vue.use(VueMeta);
Vue.use(VueObserveVisibility);
Vue.use(Vuex);
Vue.use(VueMoment);
Vue.use(VueAnalytics, {
  id: "UA-66127738-1",
  ecommerce: {
    enabled: true,
    enhanced: true
  }
  // ,
  // debug: {
  //   enabled: false,
  //   trace: true,
  //   sendHitTask: true
  // }
});
Vue.use(VeeValidate, {
  classes: true
});
Vue.use(VTooltip);
Vue.use(VueScrollTo);
Vue.use(vMediaQuery.default);
Vue.use(VModal, { dynamic: true, dialog: true, injectModalsContainer: true });
Vue.use(VueLazyload, {
  preLoad: 0.8,
  error: "/img/logo_mobile.png",
  loading: "/img/hh_logo.png",
  attempt: 2,
  filter: {
    webp(listener, options) {
      return listener.src;

      // TODO fix this when CDN is ready
      // if (!options.supportWebp) return;
      // listener.src += ".webp";
    }
  }
});
Vue.use(VueTimeago, {
  name: "Timeago",
  locale: appConfig.cultureLocale,
  locales: {
    // eslint-disable-next-line
    en_US: require("date-fns/locale/en"),
    // eslint-disable-next-line
    th_TH: require("date-fns/locale/th"),
    // eslint-disable-next-line
    ko_KR: require("date-fns/locale/ko")
  }
});
Vue.use(VueClipboard);
Vue.component("p-check", PrettyCheck);
Vue.component("p-radio", PrettyRadio);

// check if layout is plain, to disable/hide some features
const urlParams = new URLSearchParams(window.location.search);
const layout = urlParams.get("layout");
const store = new Vuex.Store(vuexStore());

Vue.mixin({
  computed: {
    isMobile() {
      return this.$mq.resize && this.$mq.below(640);
    },
    isDesktop() {
      return this.$mq.resize && this.$mq.above(639);
    },
    isTHLang() {
      const pathName = window.location.pathname;
      if (pathName.includes("en")) {
        return false;
      }
      return true;
    },
    isLayoutPlain() {
      return layout === "plain";
    },
    criteoSiteType() {
      return this.isMobile ? "m" : "d";
    },
    criteoID() {
      return 65114;
    },
    criteoEmail() {
      if (this.currentUser && this.currentUser.email) {
        return this.currentUser.email;
      }
      return "";
    },
    isUserSignedIn() {
      return this.$store?.getters?.isUserSignedIn;
    },
    currentUser() {
      return this.$store?.getters?.currentUser;
    },
  },
  methods: {
    tryWebpFormat(url) {
      return url;

      // TODO fix this when CDN is ready
      // if (window.Modernizr.webp) {
      //   return `${url}.webp`;
      // }

      // return url;
    },
    cdnUrl
  }
});

$(document).ready(() => {
  // if (process.env.IS_LOCAL) {
  //   window.MiniProfiler.pageTransition();
  // }

  // Main App, in the future, all pages should use this Vue instance
  // eslint-disable-next-line
  new Vue({
    i18n,
    store,
    render: h => h(App)
  }).$mount("#app");

  window.$ = $;

  const token = Cookies.get("csrftoken");

  $("<meta>")
    .attr("name", "csrf-param")
    .attr("content", "authenticity_token")
    .appendTo("head");

  $("<meta>")
    .attr("name", "csrf-token")
    .attr("content", token)
    .appendTo("head");

  if ($("#flash-alert").length) {
    alert.error($("#flash-alert").text(), { layout: "topCenter" });
  }

  if ($("#flash-notice").length) {
    alert.info($("#flash-notice").text(), { layout: "topCenter" });
  }

  // if layout is plain, disable zendesk chat widget
  if (layout === "plain") return;
  let duplicateChat = false;
  const zendeskEl = $(".zopim, .zEWidget-webWidget");
  if (zendeskEl.length) {
    zendeskEl.each((k, v) => {
      try {
        if ($(v).visible()) {
          duplicateChat = true;
        }
      } catch (e) { }

      if (!duplicateChat) {
        zendeskWebWidget();
        duplicateChat = true;
      }
    });
  } else {
    zendeskWebWidget();
  }
});
